<template>
  <v-container fluid fill-height class="pa-0 ma-0 narekomu-back " >
    <div class="login-back people"></div>
    <v-card v-if="isError" class="login-card">
      <dialog-error :text="errorText" to-top="true" />
    </v-card>
    <v-card v-else-if="!isComplete" id="login-card" class="elevation-1   login-card  body-2" >
      <v-toolbar
          color="blue-grey darken-4"
          dark
          flat
          height="80"
      >    
        <v-row justify="center">
          <v-text class="text-h6">パスワードの再設定</v-text>
        </v-row>
      </v-toolbar>
      <v-card-text  class="mt-3 pt-2 pb-1">
        新しいパスワードを入力してください。
        <v-form ref="form" v-model="valid" lazy-validation  @submit.prevent>
          <v-text-field
              v-model="password1"
              :rules="rules"
              type="password"
              maxlength="50"
              label="新しいパスワード"
            ></v-text-field>

            <v-text-field
              v-model="password2"
              :rules="rules"
              type="password"
              maxlength="50"
              label="新しいパスワード(確認用)"
            ></v-text-field>
        </v-form>
      </v-card-text>
 

   
      <div class="login-btn px-4 pb-4">
        <v-btn 
          block 
          color="blue-grey darken-4 white--text"
          :loading="loading"
          :disabled=" !valid || password1!=password2 || password1=='' "
          @click="sendData"
          >送信</v-btn>
      </div>
    </v-card>
    <v-card v-else class="login-card" > 
      <DialogComplete
        text="変更が完了しました。"
        toTop="true"
      />
    </v-card>
   </v-container>
</template>

<script>
import axios from "axios"

const DialogComplete = () => import('@/components/DialogComplete.vue');
const  DialogError = () => import('@/components/DialogError.vue');

export default {
  components: { DialogComplete,DialogError },
  name: 'Reset',
  data: () => ({
    loading: false,
    password1:"",
    password2:"",
    valid:true,
    sign:null,
    token:null,
    isComplete:false,
    isError:false,
    errorText:"",
    rules: [
      v => !!v || "パスワードは必須項目です。",
      v => (v && v.length >= 8) || "8文字以上で入力してください。",
      v => (v && v.length <= 32) || "パスワードは32文字以内で入力してください。",
    ],
    email: "",
  }),

  created(){
    if(this.$route.query.token==undefined | this.$route.query.sign==undefined){
      this.isError = true;
      this.errorText="URLが無効です"
    }
    this.token = this.$route.query.token;
    this.sign = this.$route.query.sign;
  },

  methods:{
    //パスワードの再設定のメールの送付
    sendData(){
      this.loading = true;
      axios({
        method: "PUT",
        url:`https://m3x83t36og.execute-api.ap-northeast-1.amazonaws.com/dev/v1/password/reset`,
        headers: {"X-Api-Key": process.env.VUE_APP_KEY,"Content-Type":"application/json"},
        data:{
          "sign":this.$route.query.sign,
          "token":this.$route.query.token,
          "password":this.password1
        },
      }).then((response) => {
        if(response.data.results=="complete"){
            this.isComplete=true;
            this.loading = false;
        }else{
          this.loading = false;
          this.isError = true;
          this.errorText="エラーが発生しました";
        }
      }).catch(() => {
        // console.log(reason)
        this.loading = false;
        this.isError = true;
        this.errorText="エラーが発生しました";
      });
    },
  }


}
</script>

<style  scoped>
    .login-card {
        width:400px;
        margin:-250px auto 0 auto;
        z-index:2000;
    }

    .narekomu-back{
        /* background: url("../assets/login-narekomuvr.jpg"); */
        background-size: cover;
        background-position: center center;
        width: 100%;

    }

    #no-background-hover::before {
      background-color: transparent !important;
    }

.login-back{
      position:absolute;
       left: 0;
      right: 0;
      margin: auto;
      width:100%;
      max-width:1400px;
      height:100%;
    }

    .people{
      animation: fadein 0.4s ease-out forwards;
      background: url("~@/assets/people.webp") no-repeat center center;
      background-size:auto 100%;
    }

    .male{
      position:absolute;
  
      right:0%;
      height:100%;
      max-width:850px;
      min-width:100px;
      bottom:0;
      z-index:1000;
      object-fit:cover;
      object-position:right top;
    }

    .female{
      position:absolute;
      height:100%;
      left:0%;
      bottom:0;
      z-index:900;
      max-width:850px;
      min-width:100px;
      object-fit:cover;
      object-position:left top;
    }


    @media screen and (max-width: 1000px) {
      .male{
         position:absolute;
        height:100%;
        left:0;
        max-width:850px;
        min-width:100px;
        width:50%;
        bottom:0;
        z-index:1000;
        object-fit:cover;
        object-position:50% top;
      }

      .female{
        position:absolute;
        height:100%;
        left:50%;
        bottom:0;
       
        z-index:900;
        max-width:850px;
        min-width:100px;
        width:60%;
        object-fit:cover;
        object-position:50% top;
      } 

    }

</style>